import { render, staticRenderFns } from "./fotodatenbank.vue?vue&type=template&id=788b737c&scoped=true&"
import script from "./fotodatenbank.vue?vue&type=script&lang=js&"
export * from "./fotodatenbank.vue?vue&type=script&lang=js&"
import style0 from "./fotodatenbank.vue?vue&type=style&index=0&id=788b737c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788b737c",
  null
  
)

export default component.exports